export default {
  fetching: true,
  error: null,
  data: {
    data: {
      overall: {},
      ward_wise: {},
      year_wise: {}
    },
    message: "",
    metadata: [],
    success: false
  },
  selectedWard: "all"
};



// WEBPACK FOOTER //
// ./src/infraMonitor/projects-stats/initialState.js